import { Chip, ChipOwnProps, Color } from "@mui/material";
import { DBAccount } from "../../../api/types";

export type SettingChipsParameters = {
  account: DBAccount;
};

const getLongShortChips = ({
  disableLong,
  disableShort,
}: {
  disableLong?: boolean;
  disableShort?: boolean;
}): Array<{
  text: string;
  color: ChipOwnProps["color"];
}> => {
  if (disableLong && disableShort) {
    return [{ text: `Long & Short Disabled`, color: "error" }];
  }

  if (!disableLong && !disableShort) {
    return [{ text: `Long & Short Enabled`, color: "info" }];
  }

  if (disableLong) {
    return [
      { text: `Long Disabled`, color: "warning" },
      { text: `Short Enabled`, color: "info" },
    ];
  }

  if (disableShort) {
    return [
      { text: `Long Enabled`, color: "info" },
      { text: `Short Disabled`, color: "warning" },
    ];
  }

  return [{ text: `Error evaluating setting`, color: "error" }];
};

export const SettingChips = ({ account }: SettingChipsParameters) => {
  const { disableLong, disableShort } = account.settings;

  const longShortChips = getLongShortChips({ disableLong, disableShort });

  return (
    <>
      {longShortChips.map((chip) => (
        <Chip
          key={chip.text}
          color={chip.color}
          variant="outlined"
          sx={{ mr: 1 }}
          label={chip.text}
        />
      ))}
    </>
  );
};
